import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  all: [],
  columns: [
    {
      label: 'Name', field: 'name'
    },
    {
      label: 'Description', field: 'desc'
    },
    {
      label: 'Action', field: 'action'
    }
  ],
  pages: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'master/languages/status/AC'}
    useIPA.get(param).then(response => {
      const language = {
        rows : response.data.data,
        pages : [10, 25, 50, 150]
      }
      commit('setData', {...language})
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'master/language/' + id}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const rawData = {
        name: formData.text_1,
        desc: formData.text_2
			}
      const param = { rawData: rawData, url: 'dashboard/master/language', id: formData.id }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'language' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/language', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, language) {
    state.all = language.rows
    state.pages = language.pages
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
